import DateFieldTemplate from './widgets/DateFieldTemplate'
import LongRadioWidget from './widgets/LongRadioWidget'
import ConsentCheckboxWidget from './widgets/ConsentCheckboxWidget'

export const uiSchema = {
  personalDataConsent: {
    "ui:widget": ConsentCheckboxWidget
  },
  positivePcrTest: {
    "ui:widget": LongRadioWidget
  },
  vaccination: {
    "ui:widget": "radio"
  },
  vaccinationDate: {
    "ui:ObjectFieldTemplate": DateFieldTemplate
  },
  diagnosisDate: {
    "ui:ObjectFieldTemplate": DateFieldTemplate
  },
  gender: {
    "ui:widget": "radio"
  },
  everydayLife: {
    "ui:widget": LongRadioWidget
  },
  email: {
    "ui:options": {
      inputType: "email"
    }
  }
};

export default uiSchema;
